"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.nextLawLex = exports.transforms = void 0;
exports.transforms = {
    fromRaw: function (lawlex, _a) {
        var prefix = _a.prefix, suffix = _a.suffix;
        var lawLexRegex = new RegExp("^".concat(prefix, "([0-9]{4})0*([0-9]+)").concat(suffix, "$"));
        var match = lawlex.match(lawLexRegex);
        if (!match) {
            throw new Error('Problem computing next lawlex number');
        }
        var _b = __read(match, 3), year = _b[1], number = _b[2];
        return {
            number: number,
            prefix: prefix,
            suffix: suffix,
            year: year,
        };
    },
    toRaw: function (_a) {
        var prefix = _a.prefix, suffix = _a.suffix, year = _a.year, number = _a.number;
        return "".concat(prefix).concat(year).concat("00000000".concat(number).slice(-8)).concat(suffix);
    },
};
var nextLawLex = function (_a) {
    var prefix = _a.prefix, suffix = _a.suffix, year = _a.year, number = _a.number;
    var currentYear = new Date().getFullYear();
    if (currentYear !== year) {
        number = 0;
    }
    return {
        number: number + 1,
        prefix: prefix,
        suffix: suffix,
        year: currentYear,
    };
};
exports.nextLawLex = nextLawLex;
//# sourceMappingURL=lawLexIdFactory.js.map